<template>
  <panel
    :icon="icon"
    :heading="heading"
  >
    <template v-if="$store.getters['flashcardStates/lastUpdatedAt']['flashcards']">
      <template v-if="purchasedSim">
        <div class="sim-list">
          <div
            v-for="category in categories"
            :key="category.id"
            :class="{ notFinished: !finishedSimulation(category) }"
          >
            <div class="name">
              {{ category.name }}
            </div>
            <div class="action">
              <router-link
                v-if="finishedSimulation(category)"
                :to="{ name: 'testSimulations#results', params: { categoryId: category.id }, query: simQuery }"
              >
                View Results
              </router-link>
              <button
                v-else-if="$access($store, 'category', category.id)"
                @click="start(category)"
              >
                Take Now
              </button>
              <button
                v-else
                @click.prevent.stop="lockedAction(category)"
              >
                Buy Now
              </button>
            </div>
            <div class="date">
              {{ simDate(category) }}
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="prompt-text">
          Take a full-length simulation test to know your strongest and weakest categories.
        </div>
        <button
          class="prompt-button"
          @click="simNavDestination"
        >
          Learn More
        </button>
      </template>
    </template>
  </panel>
</template>

<script>
import { format } from 'date-fns';
import SimulationsMixin from '@/mixins/simulations';
import GlobalMixin from '@/mixins/global';
import Panel from '@components/singletons/panel';

export default {
  components: { Panel },
  mixins: [SimulationsMixin, GlobalMixin],
  props: {
    label: {
      type: String,
      default: '',
    },
  },
  computed: {
    categories() {
      const configs = this.$store.getters['simulationConfigs/simulationConfigs'];
      const ids = this.$store.getters['categoryTypes/testSimulationCategoryTypes'].map(t => t.id);
      return this.$store.getters['categories/all'].filter(c => {
        return ids.includes(c.categoryTypeId) && configs[c.id]?.timeInMinutes > 0;
      });
    },
    icon() {
      if (this.purchasedSim) {
        return 'simulation';
      } else {
        return 'help';
      }
    },
    heading() {
      if (this.purchasedSim) {
        return 'Simulations';
      } else {
        return 'Am I Ready?';
      }
    },
    purchasedSim() {
      return this.$store.getters['session/hasPurchasedSimulation'];
    },
    simQuery() {
      const simNavItem = this.$store.getters['navigationItems/menuItems'].find(ni => ni.destination === 'test_simulations');
      return { nav: simNavItem.query };
    },
  },
  methods: {
    lockedAction(category) {
      this.$store.dispatch('ui/toggleUpsellModal', { show: true, resource: { type: 'category', id: category.id } });
    },
    simNavDestination() {
      let item = this.$store.getters['navigationItems/menuItems'].find(ni => ni.destination === 'test_simulations');
      this.$router.push(item.route);
    },
    simDate(category) {
      if (this.finishedSimulation(category)) {
        const date = this.lastCategoryState(category).mobileCreatedAt;
        return `Completed ${format(new Date(date), 'MMM. d, yyyy')}`;
      }
    },
    start(category) {
      this.$router.push({ name: 'testSimulations#start', params: { categoryId: category.id }, query: this.simQuery });
    },
  },
};
</script>

<style lang='scss' scoped>

  .prompt-text {
    font-size: rem-calc(13);
  }

  .sim-list {
    > div {
      align-items: center;
      display: flex;
      margin-bottom: rem-calc(12);

      .name {
        color: #354052;
        flex-basis: 45%;
        font-size: rem-calc(12);
        font-weight: $semi-bold;
      }

      .action {
        font-size: rem-calc(10);
        flex-basis: rem-calc(64);
        margin: 0 rem-calc(8);
        text-align: center;

        a {
          color: #354052;
          font-size: rem-calc(10);
          text-decoration: underline;
        }
      }

      .date {
        color: #354052;
        flex: 1;
        font-size: rem-calc(10);
        text-align: right;
      }

      // first button in sim list (not link)
      &.notFinished:nth-of-type(1) button {
        background: #00D0DC;
        color: white;
      }
    }
  }

  button {
    background-color: white;
    border: 1px solid #00D0DC;
    border-radius: 4px;
    color: #00D0DC;
    cursor: pointer;
    font-size: rem-calc(10);
    font-weight: $semi-bold;
    padding: rem-calc(6) 0;
    text-align: center;
    text-transform: uppercase;
    width: rem-calc(64);

    &.prompt-button {
      display: block;
      font-weight: $bold;
      margin: rem-calc(12) 0 0 auto;
      width: rem-calc(80);
    }
  }
</style>
